import type { ConfirmMethodRequestData } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const confirmMethod = async ({
  kioskCpiId,
  data,
}: {
  kioskCpiId: string
  data: ConfirmMethodRequestData
}) => {
  const response = await gozokiApiWithAuth.post(`/kiosk/${kioskCpiId}/opening/method-confirm`, data)
  return response.data
}

export const confirmOpening = async ({
  kioskCpiId,
  data,
}: {
  kioskCpiId: string
  data: ConfirmMethodRequestData
}) => {
  const response = await gozokiApiWithAuth.post(
    `/kiosk/${kioskCpiId}/opening/opening-confirm`,
    data,
  )
  return response.data
}
